__turbopack_context__.v({
  "freeBox__ejEex": "PlasmicReviewCard-module__w54k_W__freeBox__ejEex",
  "freeBox__j2IM": "PlasmicReviewCard-module__w54k_W__freeBox__j2IM",
  "freeBox__nTsN5": "PlasmicReviewCard-module__w54k_W__freeBox__nTsN5",
  "img": "PlasmicReviewCard-module__w54k_W__img",
  "p": "PlasmicReviewCard-module__w54k_W__p",
  "root": "PlasmicReviewCard-module__w54k_W__root",
  "span": "PlasmicReviewCard-module__w54k_W__span",
  "svg": "PlasmicReviewCard-module__w54k_W__svg",
});
